import React from 'react';

/**
 * @typedef {import('./Props').default} Props
 * @typedef {import('./Props').LeadScores} LeadScores
 */

import { translate } from '../../Internationalization';

export default class LeadDate extends React.Component {
	/**
	 * @returns {JSX.Element}
	 */
	#renderLeadScore() {
		const scoreTierColor = 'text-accent-green';

		return (
			<span
				className={`${scoreTierColor} ${this.props.className} ${
					this.props.iconOrder === 'right' ? '' : 'w-6'
				}`}
			>
				{this.props.last_avm_request
					? new Date(this.props.last_avm_request).toLocaleDateString(
							'en-GB',
							{
								day: 'numeric',
								month: 'long',
								year: 'numeric',
							}
					  )
					: '-'}
			</span>
		);
	}

	render() {
		if (!this.props?.last_avm_request) {
			return (
				<span>
					{translate('agent.pages.dashboard.avmLead_board.no_date')}
				</span>
			);
		}

		const iconOrderLeft = this.props.iconOrder === 'left';

		return (
			<div
				className={`items-center align-middle ${
					iconOrderLeft ? 'flex-row-reverse' : 'flex-row'
				}`}
			>
				{this.#renderLeadScore()}
			</div>
		);
	}
}
